import React from 'react';

const isInteriorDesign = (service) =>
  service?.ServiceName?.toLowerCase().includes('interior design');

export default function StepNavigation({
  step,
  loading,
  setStep,
  isStepValid,
  handleNextStep,
  handleConfirmPayment,
  selectedService,
}) {
  if (step === 6 || step === 9 || loading) return null;
  if (step > 5 && step !== 7 && step !== 8) return null;

  const handleBack = () => {
    if (step === 7) {
      setStep(1);
    } else if (step === 8) {
      setStep(7);
    } else if (step === 2 && isInteriorDesign(selectedService)) {
      setStep(7);
    } else {
      setStep((prev) => prev - 1);
    }
  };

  const isChoice = step === 7;

  return (
    <div className="action-container">
      <div className="btn-group">
        {(step > 1 || step === 7) && (
          <button className="preview-btn" onClick={handleBack}>
            Previous
          </button>
        )}
        {!isChoice && (
          <button
            className="next-btn"
            onClick={step === 5 ? handleConfirmPayment : handleNextStep}
            disabled={!isStepValid()}
          >
            {step === 5 ? 'Confirm' : 'Next'}
          </button>
        )}
      </div>
    </div>
  );
}
